// lib/applyFilters.js — v119.236 Unified "Apply Filters" (زر تطبيق) pattern.
// Prevents auto-refetch while the user is still adjusting filters — data
// loads only when 🎯 «تطبيق» is clicked (saves API calls + LLM credits).
import React, { useCallback, useState } from "react";

export function useAppliedFilters(current) {
  const [applied, setApplied] = useState(current);
  const dirty = JSON.stringify(current) !== JSON.stringify(applied);
  const apply = useCallback(() => setApplied(current), [current]);
  return { applied, dirty, apply };
}

export function ApplyButton({ dirty, onApply, onRefresh, testId = "apply-filters-btn" }) {
  return (
    <button
      type="button"
      onClick={dirty ? onApply : onRefresh}
      data-testid={testId}
      aria-label={dirty ? "تطبيق الفلاتر" : "تحديث"}
      style={{
        background: dirty ? "linear-gradient(135deg,#4a2c1a,#8b5a2b)" : "#fff",
        border: `1.5px solid ${dirty ? "#4a2c1a" : "#e3d5bd"}`,
        borderRadius: 999,
        padding: dirty ? "6px 18px" : 0,
        width: dirty ? "auto" : 34,
        height: 34,
        color: dirty ? "#ffd97a" : "#5c3a1e",
        cursor: "pointer",
        fontSize: dirty ? 12.5 : 15,
        fontWeight: 800,
        fontFamily: "inherit",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: dirty ? 4 : 0,
        flexShrink: 0,
        transition: "background .15s ease, color .15s ease",
        boxShadow: dirty ? "0 3px 10px -3px rgba(61,28,8,0.35)" : "none",
      }}
    >
      {dirty ? "🎯 تطبيق" : "↻"}
    </button>
  );
}
